<template>
  <div>
    <b-container fluid class="mt-5">
      <b-row class="justify-content-center">
        <b-col cols="8" lg="3">
          <div class="left-part box-shadow">
            <Sidebar @clicked="loadChild" />
          </div>
        </b-col>

        <b-col cols="12" lg="9">
          <div class="right-part box-shadow" v-if="user">
            <Message v-if="user_body === 'message'" :user="user" />

            <Notification v-if="user_body === 'notification'" :user="user" />

            <BasicInfo v-if="user_body === 'basic-info'" :user="user" />

            <Activity v-if="user_body === 'activity'" :user="user" />

            <Payment v-if="user_body === 'payment'" :user="user" />

            <Setting v-if="user_body === 'setting'" :user="user" />
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      ref="alert-modal"
      centered
      size="lg"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row class="justify-content-center">
        <b-col cols="6" class="p-3">
          <b-img
            :src="require('@/assets/img/guider/no-entry.png')"
            fluid
          />
        </b-col>
      </b-row>

      <b-row class="mt-3 justify-content-center">
        <b-col cols="12" class="text-center">
          <h2>
            Hello captain!
          </h2>
          <h4>To manage your profile please login to capt.starguides.co</h4>
        </b-col>
      </b-row>

      <b-row class="mt-3 justify-content-center">
        <b-col cols="4">
          <b-button size="lg" block variant="success" @click="openCaptApp">Understand</b-button>
        </b-col>
        <b-col cols="4">
          <b-button size="lg" block variant="success" @click="updateCustomer">Continue as Customer</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
// external dependencies
import VueJwtDecode from 'vue-jwt-decode'
import swal from 'sweetalert'

// custom component
import Message from '@/components/Messages'
import Notification from '@/components/Notification'
import Sidebar from '@/components/MyAccount/Sidebar'
import BasicInfo from '@/components/MyAccount/BasicInfo'
import Activity from '@/components/MyAccount/Activity'
import Payment from '@/components/MyAccount/Payment'
import Setting from '@/components/MyAccount/Setting'

// api call
import UserAPI from '@/api/UserAPI'

export default {
  name: 'MyAccount',
  components: {
    Sidebar,

    BasicInfo,
    Message,
    Notification,
    Activity,
    Payment,
    Setting
  },
  data () {
    return {
      user_body: 'basic-info'
    }
  },
  beforeCreate: function () {
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user = decode
    } else {
      this.user = null
      this.$router.push({ name: 'Login' })
    }
  },
  mounted: function () {
    if (this.user && !this.user.is_customer) {
      this.$refs['alert-modal'].show()
    }
  },
  methods: {
    // PREREQUISITES
    loadChild: function (param) {
      this.user_body = param
    },
    openCaptApp: function () {
      this.$session.destroy()

      this.$cookies.remove(`user_session`)
      this.$cookies.remove(`order_data`)
      this.$cookies.remove(`payment_data`)

      window.location.href = 'http://capt.starguides.co/'
    },
    updateCustomer: async function () {
      try {
        await UserAPI.changeStatusGuiderCustomer({
          sg_user_id: this.user._id,
          type: `customer`
        })
        this.$refs['alert-modal'].hide()
      } catch (error) {
        swal({
          title: 'Update profile error!',
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })
      }
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
/* remove bootstrap modal default style */
.modal-content {
  border: 0px solid !important;
  background-color: transparent !important;
}
.modal-body {
  border-radius: 15px;
  border: 0px solid !important;
  background-color: white !important;
}

.box-shadow {
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  background-color: #fafafa;

  min-height: 350px;
}

@media screen and (min-width: 1080px) {
  .left-part {
    margin-left: 6rem;
  }
  .right-part {
    margin-right: 6rem;
  }
}
@media screen and (max-width: 1079px) and (min-width: 980px) {
  .left-part {
    margin-left: 3rem;
  }
  .right-part {
    margin-right: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MyAccount.vue